// import React, { Fragment, useState, useEffect } from "react";
// import { connect } from "react-redux";
// import { FeedbackProvider } from "./context/cmscontext";
// import "animate.css";
// import {
//   // BrowserRouter as Router,
//   Switch,

//   Route,
// } from "react-router-dom";
// import "./App.css";
// import { useLocation } from 'react-router-dom'
// import { AuthRoute, PrivateRoute } from "./router/index";
// import CurveNavbar from "./components/Navbar/CurveNavbar";

// import * as Pages from "./pages/index";
// import Toaster from "./components/Toaster";
// import OverLayLoader from "./components/OverLayLoader";

// import Footer from "./components/Footer";
// import FooterMini from "./components/Footer Social";
// import { get } from "./services/localStorage";
// import { LOGIN, LOG_OUT } from "./constant";
// // import 'semantic-ui-css/semantic.min.css'
// //
// function App(props) {

//   // =================================this is vender side project ============================
//   const { auth, login, logOut } = props;
//   const localStorage_auth = () => {
//     const localStorage_auth_data = get({ key: "auth" });
//     return localStorage_auth_data
//       ? localStorage_auth_data.token
//         ? localStorage_auth_data
//         : {}
//       : {};
//   };
//   // console.warn = () => {};
//   // console.log = console.warn = console.error = () => {};
//   useEffect(() => {
//     const auth_data = localStorage_auth();
//     if (!auth.token && auth_data.token) {
//       login(auth_data);
//     } else if (auth.token && !auth_data.token) {
//       logOut();
//     }
//   }, [auth]);
//   //
//   const [navbarDimensions, setnavbarDimensions] = useState({
//     width: 0,
//     height: 72,
//   });

//   const location = useLocation();
//   // // console.log"Location ",location)
//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       left: 0,
//       behavior: "instant",
//     });
//   }, [location]);

//   return (
//     <>
//       <FeedbackProvider>
//         {location.pathname === "/dealers/carreport" ||
//         location.pathname === "/dealers/contactusmobile" ||
//         location.pathname === "/dealers/termsmobile" ||
//         location.pathname === "/dealers/privacypolicymobile" ||
//         location.pathname === "/dealers/faqsmobile" ||
//         location.pathname === "/dealers/requridocumentsmobile" ||
//         location.pathname === "/dealers/aboutusmobile" ||
//         location.pathname.includes("/dealers/carreportmobile") || location.pathname.includes("/dealers/report") ? null : (
//           <div className="fixed-top">
//             <CurveNavbar
//               setnavbarDimensions={setnavbarDimensions}
//               auth={auth}
//             />
//           </div>
//         )}

//         <div
//           style={{
//             maxWidth: navbarDimensions.width,
//             height: navbarDimensions.height,
//           }}
//         />
//         <Switch>
//           <Route exact path="/dealers/evaluation">
//             <Pages.Evaluation navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/contactus">
//             <Pages.ContactUs navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/contactusmobile">
//             <Pages.ContactUs navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/privacypolicy">
//             <Pages.PrivacyPolicy navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/privacypolicymobile">
//             <Pages.PrivacyPolicy navbarDimensions={navbarDimensions} />
//           </Route>

//           <Route exact path="/dealers/faqs">
//             <Pages.FAQs navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/faqsmobile">
//             <Pages.FAQs navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/carreportmobile/:Id">
//             <Pages.CarReportMobile navbarDimensions={navbarDimensions} />
//           </Route>

//           <Route exact path="/dealers/requridocuments">
//             <Pages.Documents navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/requridocumentsmobile">
//             <Pages.Documents navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/terms">
//             <Pages.Terms navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/termsmobile">
//             <Pages.Terms navbarDimensions={navbarDimensions} />
//           </Route>

//           <Route exact path="/dealers/aboutus">
//             <Pages.AboutUs navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/aboutusmobile">
//             <Pages.AboutUs navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/forgetpassword">
//             <Pages.Forget navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/shiping">
//             <Pages.Shiping navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/carupdate">
//             <Pages.CarUpdate navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/carsteps">
//             <Pages.CarSteps navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/bookappointment">
//             <Pages.EvaluationNew navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/carreport">
//             <Pages.CarReport navbarDimensions={navbarDimensions} />
//           </Route>

//           <Route exact path={`/resetpassword/:id/:token`}>
//             <Pages.ChagePassword navbarDimensions={navbarDimensions} />
//           </Route>

//           <Route exact path="/dealers/cardamage">
//             <Pages.CarDamage navbarDimensions={navbarDimensions} />
//           </Route>
//           {/* <Route exact path="/dealers/myappointment">
//           <Pages.MyAppointment navbarDimensions={navbarDimensions} />
//         </Route> */}
//           <Route exact path="/dealers/myappointmentupdate">
//             <Pages.Appoinmentupdate navbarDimensions={navbarDimensions} />
//           </Route>

//           <Route exact path="/dealers/myappointmentdetail">
//             <Pages.MyAppointmentDetail navbarDimensions={navbarDimensions} />
//           </Route>
//           <Route exact path="/dealers/cardetail">
//             <Pages.CarDetail navbarDimensions={navbarDimensions} />
//           </Route>
//           <PrivateRoute path="/dealers/dashbord" auth={auth}>
//             <Pages.Dashboard navbarDimensions={navbarDimensions} />
//           </PrivateRoute>
//           <PrivateRoute exact path="/dealers/pdf/:id/report" auth={auth}>
//             <Pages.PDF navbarDimensions={navbarDimensions} />
//           </PrivateRoute>
//           <PrivateRoute exact path="/dealers/showInterest" auth={auth}>
//             <Pages.ShowInterest navbarDimensions={navbarDimensions} />
//           </PrivateRoute>

//           <PrivateRoute exact path="/dealers/shipingform" auth={auth}>
//             <Pages.ShipingForm navbarDimensions={navbarDimensions} />
//           </PrivateRoute>
//           <PrivateRoute exact path="/dealers/winer" auth={auth}>
//             <Pages.Winers navbarDimensions={navbarDimensions} />
//           </PrivateRoute>

//           <PrivateRoute exact path="/dealers/find-car-details" auth={auth}>
//             <Pages.ShowInterestDetails navbarDimensions={navbarDimensions} />
//           </PrivateRoute>
//           <PrivateRoute exact path="/dealers/myInterest" auth={auth}>
//             <Pages.MyInterest navbarDimensions={navbarDimensions} />
//           </PrivateRoute>
//           <AuthRoute exact path="/dealers/login" auth={auth}>
//             <Pages.Login navbarDimensions={navbarDimensions} />
//           </AuthRoute>
//           <AuthRoute exact path="/dealers/signup" auth={auth}>
//             <Pages.Signup navbarDimensions={navbarDimensions} />
//           </AuthRoute>
//           <PrivateRoute exact path="/dealers/auction" auth={auth}>
//             {/* <Pages.ComingSoon navbarDimensions={navbarDimensions || {}} /> */}
//             <Pages.AuctionDashboard navbarDimensions={navbarDimensions || {}} />
//           </PrivateRoute>
//           <PrivateRoute exact path="/dealers/buynow" auth={auth}>
//             <Pages.Buynow />
//             {/* <Pages.ComingSoon navbarDimensions={navbarDimensions || {}} /> */}
//           </PrivateRoute>
//           {/* <Route exact path="/dealers/product" children={Pages.ProductMain} /> */}
//           <Route exact path="/dealers/product">
//             <Pages.ProductMain navbarDimensions={navbarDimensions || {}} />
//           </Route>
//           <Route exact path="/dealers/productbuy">
//             <Pages.ProductMainBuy navbarDimensions={navbarDimensions || {}} />
//           </Route>

//           <Route exact path="/dealers">
//             <Pages.Landingmain navbarDimensions={navbarDimensions} />
//           </Route>
//           {/* <Redirect from="/dealers" to="/dealers" /> */}
//         </Switch>
//         <Toaster />
//         <OverLayLoader />

//         {location.pathname === "/dealers/carreport" ||
//         location.pathname === "/dealers/contactusmobile" ||
//         location.pathname === "/dealers/termsmobile" ||
//         location.pathname === "/dealers/privacypolicymobile" ||
//         location.pathname === "/dealers/faqsmobile" ||
//         location.pathname === "/dealers/requridocumentsmobile" ||
//         location.pathname === "/dealers/aboutusmobile" ||
//         location.pathname.includes("/dealers/dashbord")  ||
        
//         location.pathname.includes("/dealers/carreportmobile") || location.pathname.includes("/dealers/report") ? null : (
//           <footer
//             style={{
//               backgroundColor: "#F2F4F5",
//               // borderTop
//               borderTopWidth: "1px",
//               borderTopStyle: "solid",
//               borderTopColor: "black",
//               position:"relative"
//             }}
//           >
//             <Footer />
//             <FooterMini></FooterMini>
//           </footer>
//         )}
//       </FeedbackProvider>
//     </>
//   );
// }
// const mapStateToProps = (state) => ({
//   auth: state.auth,
// });
// const mapDispatchToProps = (dispatch) => ({
//   login: (data) =>
//     dispatch({
//       type: `${LOGIN}_SUCCESS`,
//       payload: { ...data },
//     }),
//   logOut: (data) =>
//     dispatch({
//       type: LOG_OUT,
//     }),
// });

// export default connect(mapStateToProps, mapDispatchToProps)(App);


import React, { Fragment, Suspense, useState, useEffect } from "react";
import { connect } from "react-redux";
import { FeedbackProvider } from "./context/cmscontext";
import "animate.css";
import {
  // BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import "./App.css";
import { useLocation } from 'react-router-dom'
import { AuthRoute, PrivateRoute } from "./router/index";
import CurveNavbar from "./components/Navbar/CurveNavbar";

import * as Pages from "./pages/index";
import Toaster from "./components/Toaster";
import OverLayLoader from "./components/OverLayLoader";

import Footer from "./components/Footer";
import FooterMini from "./components/Footer Social";
import { get } from "./services/localStorage";
import { LOGIN, LOG_OUT, UPDATE_AUTH } from "./constant";
import { isDealerUser } from "./utils/userTypes";
import { get as getClientAuth } from "../services/localStorage";
import {
  buildDealersAuthBlob,
  syncDealersSessionFromAuthState,
  syncDealersSessionFromHomeLogin,
} from "../utils/dealerSessionSync";
import { resolveMediaUrl } from "../utils/userIdentity";
import clientStore from "../store";
import { LOGIN as CLIENT_LOGIN } from "../constant";

const OnboardingTour = React.lazy(() => import("../components/OnboardingTour"));

function ensureClientAuthMirrorsDealer(dealerAuth) {
  if (!dealerAuth?.token || !isDealerUser(dealerAuth)) return;
  try {
    const clientAuth = getClientAuth({ key: "auth" }) || {};
    if (clientAuth.token) return;
    clientStore.store.dispatch({
      type: `${CLIENT_LOGIN}_SUCCESS`,
      payload: buildDealersAuthBlob(dealerAuth),
    });
  } catch (e) {
    /* ignore */
  }
}

function App(props) {
  // =================================this is vender side project ============================
  const { auth, login, logOut, updateAuth } = props;
  const localStorage_auth = () => {
    const localStorage_auth_data = get({ key: "auth" });
    return localStorage_auth_data
      ? localStorage_auth_data.token
        ? localStorage_auth_data
        : {}
      : {};
  };
  // console.warn = () => {};
  // console.log = console.warn = console.error = () => {};
  useEffect(() => {
    const auth_data = localStorage_auth();
    if (!auth.token && auth_data.token) {
      // Restore only dealer sessions into the dealers portal.
      if (isDealerUser(auth_data)) {
        login(auth_data);
        ensureClientAuthMirrorsDealer(auth_data);
      } else {
        logOut();
      }
      return;
    }
    if (auth.token && !auth_data.token) {
      logOut();
      return;
    }
    if (auth.token && !isDealerUser(auth)) {
      logOut();
      return;
    }
    // Home-login sync: dealer session may only exist in ATP_localstorage_auth.
    if (!auth.token && !auth_data.token) {
      try {
        const clientAuth = getClientAuth({ key: "auth" }) || {};
        if (clientAuth.token && isDealerUser(clientAuth)) {
          syncDealersSessionFromHomeLogin(clientAuth);
          login(buildDealersAuthBlob(clientAuth));
        }
      } catch (e) {
        /* ignore */
      }
      return;
    }

    // Pull newer profile/avatar from dealers LS or main-site session.
    if (auth.token && isDealerUser(auth)) {
      ensureClientAuthMirrorsDealer(auth);
      const patch = {};
      const applyProfileFields = (source) => {
        if (!source || !source.token) return;
        if (
          source.id != null &&
          auth.id != null &&
          String(source.id) !== String(auth.id)
        ) {
          return;
        }
        if (source.image && source.image !== auth.image) {
          const resolved = resolveMediaUrl(source.image);
          if (resolved && resolved !== auth.image) {
            patch.image = resolved;
          }
        }
        const first =
          source.firstname || source.first_name || "";
        const last = source.lastname || source.last_name || "";
        if (first && first !== auth.firstname) {
          patch.firstname = first;
          patch.first_name = first;
        }
        if (last && last !== auth.lastname) {
          patch.lastname = last;
          patch.last_name = last;
        }
      };
      applyProfileFields(auth_data);
      try {
        const clientAuth = getClientAuth({ key: "auth" }) || {};
        if (clientAuth.token && isDealerUser(clientAuth)) {
          applyProfileFields(clientAuth);
        }
      } catch (e) {
        /* ignore */
      }
      if (Object.keys(patch).length) {
        const next = { ...auth, ...patch };
        syncDealersSessionFromAuthState(next);
        updateAuth(patch);
      }
    }
  }, [auth]);
  //
  const [navbarDimensions, setnavbarDimensions] = useState({
    width: 0,
    height: 72,
  });

  const location = useLocation();
  const isDealersHome =
    location.pathname === "/dealers" || location.pathname === "/dealers/";
  const isDealersAuth =
    location.pathname === "/dealers/login" ||
    location.pathname === "/dealers/signup" ||
    location.pathname === "/dealers/forgetpassword";
  const isDealersDashboard = location.pathname.includes("/dealers/dashbord");
  const isPdfReport = location.pathname.includes("/dealers/pdf/");

  // // console.log"Location ",location)
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [location]);

  useEffect(() => {
    const root = document.documentElement;
    const body = document.body;
    if (!isDealersDashboard && !isPdfReport) return undefined;
    const prevHtmlOverflow = root.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    root.style.overflow = "hidden";
    body.style.overflow = "hidden";
    return () => {
      root.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
    };
  }, [isDealersDashboard, isPdfReport]);

  return (
    <>
      <FeedbackProvider>
        <div
          className={[
            isDealersHome ? "pi-home-shell" : "",
            isDealersDashboard ? "dealers-dashboard-mode" : "",
          ]
            .filter(Boolean)
            .join(" ") || undefined}
        >
        {location.pathname === "/dealers/carreport" ||
        location.pathname === "/dealers/contactusmobile" ||
        location.pathname === "/dealers/termsmobile" ||
        location.pathname === "/dealers/privacypolicymobile" ||
        location.pathname === "/dealers/faqsmobile" ||
        location.pathname === "/dealers/requridocumentsmobile" ||
        location.pathname === "/dealers/aboutusmobile" ||
        isDealersAuth ||
        isDealersDashboard ||
        isPdfReport ||
        location.pathname.includes("/dealers/carreportmobile") || location.pathname.includes("/dealers/report") ? null : (
          <div
            className={[
              "fixed-top",
              "pi-header-fixed",
              isDealersHome ? "dealers-nav--hero" : "",
            ]
              .filter(Boolean)
              .join(" ")}
          >
            <CurveNavbar
              setnavbarDimensions={setnavbarDimensions}
              auth={auth}
              isHome={isDealersHome}
            />
          </div>
        )}

        <div
          style={{
            maxWidth: navbarDimensions.width,
            height:
              isDealersHome || isDealersAuth || isDealersDashboard || isPdfReport
                ? 0
                : navbarDimensions.height,
            flexShrink: 0,
          }}
        />
        <div
          className={isDealersDashboard ? "dealers-dashboard-main" : undefined}
        >
        <Switch>
          <Route exact path="/dealers/evaluation">
            <Pages.Evaluation navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/contactus">
            <Pages.ContactUs navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/contactusmobile">
            <Pages.ContactUs navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/privacypolicy">
            <Pages.PrivacyPolicy navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/privacypolicymobile">
            <Pages.PrivacyPolicy navbarDimensions={navbarDimensions} />
          </Route>

          <Route exact path="/dealers/faqs">
            <Pages.FAQs navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/faqsmobile">
            <Pages.FAQs navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/carreportmobile/:Id">
            <Pages.CarReportMobile navbarDimensions={navbarDimensions} />
          </Route>

          <Route exact path="/dealers/requridocuments">
            <Pages.Documents navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/requridocumentsmobile">
            <Pages.Documents navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/terms">
            <Pages.Terms navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/termsmobile">
            <Pages.Terms navbarDimensions={navbarDimensions} />
          </Route>

          <Route exact path="/dealers/aboutus">
            <Pages.AboutUs navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/aboutusmobile">
            <Pages.AboutUs navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/forgetpassword">
            <Pages.Forget navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/shiping">
            <Pages.Shiping navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/carupdate">
            <Pages.CarUpdate navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/carsteps">
            <Pages.CarSteps navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/bookappointment">
            <Pages.EvaluationNew navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/carreport">
            <Pages.CarReport navbarDimensions={navbarDimensions} />
          </Route>

          <Route exact path={`/resetpassword/:id/:token`}>
            <Pages.ChagePassword navbarDimensions={navbarDimensions} />
          </Route>

          <Route exact path="/dealers/cardamage">
            <Pages.CarDamage navbarDimensions={navbarDimensions} />
          </Route>
          {/* <Route exact path="/dealers/myappointment">
          <Pages.MyAppointment navbarDimensions={navbarDimensions} />
        </Route> */}
          <Route exact path="/dealers/myappointmentupdate">
            <Pages.Appoinmentupdate navbarDimensions={navbarDimensions} />
          </Route>

          <Route exact path="/dealers/myappointmentdetail">
            <Pages.MyAppointmentDetail navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dealers/cardetail">
            <Pages.CarDetail navbarDimensions={navbarDimensions} />
          </Route>
          <PrivateRoute path="/dealers/dashbord" auth={auth}>
            <Pages.Dashboard navbarDimensions={navbarDimensions} />
          </PrivateRoute>
          <PrivateRoute exact path="/dealers/pdf/:id/report" auth={auth}>
            <Pages.PDF navbarDimensions={navbarDimensions} />
          </PrivateRoute>
          <PrivateRoute exact path="/dealers/showInterest" auth={auth}>
            <Pages.ShowInterest navbarDimensions={navbarDimensions} />
          </PrivateRoute>

          <PrivateRoute exact path="/dealers/shipingform" auth={auth}>
            <Pages.ShipingForm navbarDimensions={navbarDimensions} />
          </PrivateRoute>
          <PrivateRoute exact path="/dealers/winer" auth={auth}>
            <Pages.Winers navbarDimensions={navbarDimensions} />
          </PrivateRoute>

          <PrivateRoute exact path="/dealers/find-car-details" auth={auth}>
            <Pages.ShowInterestDetails navbarDimensions={navbarDimensions} />
          </PrivateRoute>
          <PrivateRoute exact path="/dealers/myInterest" auth={auth}>
            <Pages.MyInterest navbarDimensions={navbarDimensions} />
          </PrivateRoute>
          {/* Auth entry lives on the main site. */}
          <Route
            exact
            path="/dealers/login"
            render={({ location: loc }) => (
              <Redirect
                to={{
                  pathname: "/login",
                  state: loc.state,
                  search: loc.search,
                }}
              />
            )}
          />
          {/* Unified signup lives on the main site; keep this path for old links. */}
          <Route
            exact
            path="/dealers/signup"
            render={({ location: loc }) => {
              const params = new URLSearchParams(loc.search || "");
              if (!params.get("role") && !params.get("type")) {
                params.set("role", "dealer");
              }
              const search = params.toString();
              return (
                <Redirect
                  to={{
                    pathname: "/signup",
                    search: search ? `?${search}` : "?role=dealer",
                  }}
                />
              );
            }}
          />
          <PrivateRoute exact path="/dealers/auction" auth={auth}>
            <Redirect to="/dealers/dashbord/auction" />
          </PrivateRoute>
          <PrivateRoute exact path="/dealers/buynow" auth={auth}>
            <Redirect to="/dealers/dashbord/buynow" />
          </PrivateRoute>
          {/* Legacy product URLs → dashboard-hosted detail */}
          <Route
            exact
            path="/dealers/product"
            render={({ location: loc }) => (
              <Redirect
                to={{
                  pathname: "/dealers/dashbord/product",
                  search: loc.search,
                  state: loc.state,
                }}
              />
            )}
          />
          <Route
            exact
            path="/dealers/productbuy"
            render={({ location: loc }) => (
              <Redirect
                to={{
                  pathname: "/dealers/dashbord/productbuy",
                  search: loc.search,
                  state: loc.state,
                }}
              />
            )}
          />

          <Route exact path="/dealers">
            <Pages.Landingmain navbarDimensions={navbarDimensions} />
          </Route>
          {/* <Redirect from="/dealers" to="/dealers" /> */}
        </Switch>
        </div>
        <Toaster />
        <OverLayLoader />
        {auth?.token && isDealerUser(auth) ? (
          <Suspense fallback={null}>
            <OnboardingTour auth={auth} audience="dealer" />
          </Suspense>
        ) : null}

        {location.pathname === "/dealers/carreport" ||
        location.pathname === "/dealers/contactusmobile" ||
        location.pathname === "/dealers/termsmobile" ||
        location.pathname === "/dealers/privacypolicymobile" ||
        location.pathname === "/dealers/faqsmobile" ||
        location.pathname === "/dealers/requridocumentsmobile" ||
        location.pathname === "/dealers/aboutusmobile" ||
        isDealersAuth ||
        isDealersDashboard ||
        isPdfReport ||
        location.pathname.includes("/dealers/carreportmobile") ||
        location.pathname.includes("/dealers/report") ? null : (
          <footer className="app-footer-shell footer-v2-shell pi-footer pi-footer--gradient dealers-footer">
            <div className="footer-v2__atmosphere pi-footer__fx" aria-hidden="true">
              <span
                className="pi-footer__photo"
                style={{
                  backgroundImage: `url(${process.env.PUBLIC_URL}/images/dealers-benefits-ops.jpg?v=1)`,
                }}
              />
              <span className="footer-v2__orb footer-v2__orb--teal" />
              <span className="footer-v2__orb footer-v2__orb--gold" />
              <span className="footer-v2__orb footer-v2__orb--violet" />
              <span className="pi-footer__grid" />
              <span className="pi-footer__aurora pi-footer__aurora--a" />
              <span className="pi-footer__aurora pi-footer__aurora--b" />
              <span className="pi-footer__beam" />
              <span className="footer-v2__mesh" />
              <span className="footer-v2__grain" />
              <span className="footer-v2__scrim" />
            </div>
            <Footer />
            <FooterMini />
          </footer>
        )}
        </div>
      </FeedbackProvider>
    </>
  );
}
const mapStateToProps = (state) => ({
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) => ({
  login: (data) =>
    dispatch({
      type: `${LOGIN}_SUCCESS`,
      payload: { ...data },
    }),
  updateAuth: (payload) =>
    dispatch({
      type: UPDATE_AUTH,
      payload: { ...(payload || {}) },
    }),
  logOut: (data) =>
    dispatch({
      type: LOG_OUT,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);